module.exports = __webpack_public_path__ + "img/webnew47.9359bbb4.jpg";